import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import notify from "../../hook/useNotification";
import avatar from "../../../src/Images/adminIcon.png";
import { addOneDocument } from "../../redux/actions/documentsActions";
import { PDFDocument } from "pdf-lib";
import { url } from "../../Api/baseURL";
import axios from "axios";


//  import * as pdfjsLib from "pdfjs-dist";
// // pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

// import { PDFDocument } from "pdf-lib";

// import { compress } from "browser-pdf-compressor";

const AdminAddDocumentHook = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [img, setImg] = useState(avatar);
  const [selectedFile, setSelectedFile] = useState("");
  const [pdffile, setPdfFile] = useState(avatar);
  const [selectedFilePdf, setSelectedFilePdf] = useState("");
  const [isFixed, setIsFixed] = useState(true);
  const [progress, setProgress] = useState(0);









  let onChangeTitle = (e) => {
    e.persist();
    setTitle(e.target.value);
  };

  //image
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0])
      setImg(URL.createObjectURL(event.target.files[0]));
      setSelectedFile(event.target.files[0]);
  };

  //pdf file
  const onPdfFileChange = (event) => {
    // console.log('done');
    if (event.target.files && event.target.files[0])
      setPdfFile(URL.createObjectURL(event.target.files[0]));
      setSelectedFilePdf(event.target.files[0]);

     // loadPdf(event.target.files[0]);

      console.log("Original size:", event.target.files[0].size / 1024 / 1024, "MB");

      
  };

  const onChangeIsFixed = (e) => {
    e.persist();
    if(e.target.value=="true") setIsFixed(true);
    if(e.target.value=="false") setIsFixed(false);
    
  };

  const onSubmit = async() => {
  //console.log("selectedFile",selectedFile);

    try {
     
    if(selectedFile=="")
    {
      notify("من فضلك قم برفع الصورة", "error");
      return;
    }

      if(title=='') 
    {
      notify("من فضلك ادخل العنوان", "error");
      return;
    }

    if(selectedFilePdf=="")
    {
      notify("من فضلك قم برفع الملف المرفق", "error");
      return;
    }

    // نضغط الملف
     // const compressedFile = await compressPdfImages(selectedFilePdf);

   
     // return;

        setLoading(true);
        const formData = new FormData();
        formData.append("title", title);
        formData.append("files", selectedFile);
        formData.append("files", selectedFilePdf);
        formData.append("isFixed", isFixed);
        
        let api=`${url}/api/v1/documents`;

        

        await axios.post(api, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          admin:true
        },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percent); // ⬅️ هنا بيزيد progress
        },
      });

     // alert("تم رفع الملف بنجاح ✅");
       // await dispatch(addOneDocument(formData));
        setLoading(false);
        notify("تم الإضافه  بنجاح", "success");

       setTimeout(() => {
         navigate(`/admin/documents`);
       }, 1500);

    } catch (error) {
       notify("حدث خطأ حاول مرة اخري", "error");
       setLoading(false);
    }
   
  };

  // useEffect(() => {
  //   if (loading === false) {
  //     //  console.log('done')
      
  //     notify("تم الإضافه  بنجاح", "success");
  //     setTimeout(() => {
  //       navigate(`/admin/documents`);
  //     }, 1500);
  //   }
  // }, [loading]);

  return [
    title,
    img,
    selectedFile,
    pdffile,
    selectedFilePdf,
    isFixed,
    onChangeTitle,
    onImageChange,
    onPdfFileChange,
    onChangeIsFixed,
    progress,
    loading,
    onSubmit
  ];
};

export default AdminAddDocumentHook;
